const ReportView = require('./ReportView');

class ReportAllView extends ReportView {
  constructor(modal, btn) {
    super(modal, btn);

    this.reportCheckBoxes = $('input.report-checkbox');
  }

  init() {
    super.init();

    this.prepareInfo();

    const $this = this;
    this.reportCheckBoxes.each(function () {
      if ($(this).is(':checked')) {
        $this.reportedTitles.push({
          idSong: $(this).data('id-song'),
          idHymn: $(this).data('id-hymn')
        });
      }
    });
  }

  prepareInfo() {
    let titles = '';
    let titlesNumber = 0;

    this.reportCheckBoxes.each(function () {
      if ($(this).is(':checked')) {
        titlesNumber++;
        titles += `<h4 class="text-center">${$(this).data('title')}</h4>`;
      }
    });

    this.showHideElements(titles, titlesNumber);
  }

  showHideElements(titles, titlesNumber) {
    this.modal.find('#report-all-info').show();
    this.modal.find('#report-single-info').hide();

    if (titlesNumber === 0) {
      this.updateHeading(__('Report titles'));
      this.modal.find('#report-titles-body').hide();
      this.modal.find('#report-no-titles-body').show();
    } else {
      this.updateHeading(__('You are reporting {count} title(s):', {
        count: `<span id="titles-number">${titlesNumber}</span>`
      }));

      this.modal.find('#titles-list').html(titles);

      this.modal.find('#report-titles-body').show();
      this.modal.find('#report-no-titles-body').hide();
    }
  }
}

module.exports = ReportAllView;
